export const config = {
   CYBRID_API : 'https://bank.production.cybrid.app',
   BACKEND_API : 'https://api.thecryptoexchange.us/',
   PERSONA_ENVIRONMENT : "production"
}
